import React from 'react';
import { useGlobalContext } from 'seagull';
import compact from 'lodash/compact';
import { MapServicesModal } from "./MapServicesModal";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
export function useOpenMapServicesModalFromInvoice(invoice, integratedInvoice, reloadInvoice) {
  const globalContext = useGlobalContext();
  const {
    USE_INVOICE_VIEWS = false
  } = useFeatureFlags();
  return async function openMapServicesModal() {
    async function getServiceTemplateIds() {
      if (!USE_INVOICE_VIEWS) {
        return compact(invoice.items.map(item => item.serviceTemplateId));
      } else {
        return compact(integratedInvoice === null || integratedInvoice === void 0 ? void 0 : integratedInvoice.items.map(item => item.serviceTemplateId));
      }
    }
    const serviceTemplateIds = await getServiceTemplateIds();
    if (!serviceTemplateIds.length) {
      globalContext.showErrorToast('An error occurred. ', 'no-services-to-map-toast');
      return;
    }
    await globalContext.showModal({
      closeOnClickOutside: false,
      closeOnEscapeKey: false,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(MapServicesModal, {
          dismissModal: dismissModal,
          serviceTemplateIds: serviceTemplateIds,
          onChange: () => reloadInvoice()
        });
      }
    });
  };
}